import {
    Box,
    Divider,
    Drawer,
    IconButton,
    Link,
    Grid,
    Typography,
    Button
} from "@mui/material";
import React, { useEffect, useState } from "react";
import close from "../../assets/icons/close.png";
import { getManualQuoteData } from "../Services/MMRfqForm";
import { formatCurrencyValue, QuoteAttachmentUrl } from "../../Utils/Constant";
import { ThreeDot } from "react-loading-indicators";

export const QuoteDrawer = ({ open, onClose, quoteId }) => {
    const [rows, setRows] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const fetchMenualQuoteData = async (payload) => {
        setIsLoading(true);
        try {
            const response = await getManualQuoteData(payload);
            if (response?.status) {
                setRows(response?.data);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error(error);
            setRows([]);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (quoteId && open == true) {
            fetchMenualQuoteData(quoteId);
        }
        setAnchorEl(null);
    }, [open]);

    const handleDownloadDrawing = () => {
        console.log("roww", rows);

        if (rows[0]?.Quote_Attachment) {
            const generateUrl = QuoteAttachmentUrl(rows[0]?.Quote_Attachment);
            const link = document.createElement("a");
            link.href = generateUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h6" fontWeight="bold">
                    Quote Details for: {rows[0]?.Quote_ID}
                </Typography>
                <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                    <img src={close} width={"14px"} alt="Close" />
                </IconButton>
            </Box>
            <Divider sx={{ my: 2 }} />
            {!isLoading ? (
                <Box display="flex" flexDirection="column" gap={2}>
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ mb: 1 }}
                    >
                        Partner Quote Details (Quoted by {rows[0]?.Created_By})
                    </Typography>
                    {/* Sample data */}
                    {[
                        { label: "Partner Name", value: rows[0]?.Partner_Name },
                        { label: "MMRFQ ID", value: rows[0]?.MM_RFQ_ID },
                        { label: "Quote ID", value: rows[0]?.Quote_ID }
                    ].map((item, index) => (
                        <Grid container spacing={2} key={index}>
                            <Grid item xs={6}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {item.label}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2">
                                    {item.value}
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                    <Divider />
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ mb: 1 }}
                    >
                        Part
                    </Typography>
                    {/* Part details */}
                    {[
                        //   { label: "Partner Name", value: rows[0].Partner_Name },
                        {
                            label: "Submission Date",
                            value: rows[0]?.Submission_Date
                        },
                        { label: "Part ID", value: rows[0]?.Part_ID },
                        { label: "Part Name", value: rows[0]?.Part_Name },
                        { label: "Part Number", value: rows[0]?.Part_Number }
                    ].map((item, index) => (
                        <Grid container spacing={2} key={index}>
                            <Grid item xs={6}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {item.label}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                {" "}
                                <Typography variant="body2">
                                    {item.value}
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                    <Divider />
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ mb: 1 }}
                    >
                        Terms & Conditions
                    </Typography>
                    {/* Terms */}
                    {[
                        {
                            label: "Payment Terms",
                            value: rows[0]?.Payment_Terms
                        },
                        { label: "Inco Terms", value: rows[0]?.Incoterms },
                        {
                            label: "Lead Time for Sample",
                            value: rows[0]?.Lead_time_for_Sample
                        },
                        {
                            label: "Lead Time for complete production",
                            value: rows[0]?.Lead_time_for_Complete_Production
                        },
                        {
                            label: "Other Terms & Conditions",
                            value: rows[0]?.Other_terms_conditions
                        },
                        {
                            label: "Quote Validity",
                            value: rows[0]?.Quote_Validity
                        }
                    ].map((item, index) => (
                        <Grid container spacing={2} key={index}>
                            <Grid item xs={6}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {item.label}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2">
                                    {item.value}
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                    <Divider />
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ mb: 1 }}
                    >
                        Price Break Up Details
                    </Typography>
                    {[
                        { label: "RM Grade", value: rows[0]?.RM_Grade },
                        { label: "RM Weight (Kg)", value: rows[0]?.RM_Weight },
                        { label: "RM Price/Kg", value: rows[0]?.RM_Price_Kg },
                        {
                            label: "Finished Weight (Kg)",
                            value: rows[0]?.Finished_Weight
                        },
                        {
                            label: "Final RM Price (INR)",
                            value: rows[0]?.Final_RM_Price
                        },
                        {
                            label: "Process Cost (INR)",
                            value: rows[0]?.Process_Cost
                        },

                        {
                            label: "OH & Profit (INR)",
                            value: rows[0]?.OH_Profit
                        },
                        {
                            label: "Packaging Charge (INR)",
                            value: rows[0]?.Packing_Charges_Unit_if_Applicable
                        },
                        {
                            label: "Transportation Cost (INR)",
                            value: rows[0]
                                ?.Transportation_Cost_Unit_if_Applicable
                        },
                        {
                            label: "Scrap Cost (INR)",
                            value: rows[0]?.Scrap_Cost
                        },

                        {
                            label: "Unit Price (INR)",
                            value: rows[0]?.Unit_Price
                        },
                        {
                            label: "Quantity/Year",
                            value:
                                rows[0]?.Quantity_Year != null
                                    ? formatCurrencyValue(
                                          rows[0].Quantity_Year
                                      )
                                    : ""
                        },

                        { label: "UOM", value: rows[0]?.UOM },
                        {
                            label: "Total Price (INR)",
                            value:
                                rows[0]?.Total_Price != null
                                    ? formatCurrencyValue(
                                          rows[0].Total_Price
                                      )
                                    : ""
                        }
                    ].map((item, index) => (
                        <Grid container spacing={2} key={index}>
                            <Grid item xs={6}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    {item.label}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2">
                                    {item.value}
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                    <Divider />
                    {rows[0]?.Is_Tool_Applicable === "Yes" && (
                        <>
                            <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                sx={{ mb: 1 }}
                            >
                                Tool Details
                            </Typography>

                            {[
                                {
                                    label: "Tool Name",
                                    value: rows[0]?.Enter_Tool_Name
                                },
                                {
                                    label: "Tool Price",
                                    value: rows[0]?.Tool_Price
                                },
                                { label: "Quantity", value: rows[0]?.Quantity },
                                { label: "UOM", value: rows[0]?.Tool_UOM },
                                {
                                    label: "Lead Time for Tool",
                                    value: rows[0]?.Lead_time_for_Tool
                                },
                                {
                                    label: "Payment Terms",
                                    value: rows[0]?.Payment_Terms_Tool
                                }
                            ].map((item, index) => (
                                <Grid container spacing={2} key={index}>
                                    <Grid item xs={6}>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            {item.label}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2">
                                            {item.value}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            ))}
                            <Divider />
                        </>
                    )}
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ mb: 1 }}
                    >
                        Attached Partner Quote
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <Typography
                                variant="body2"
                                sx={{ width: "100%", wordBreak: "break-all" }}
                            >
                                {/* {rows[0]?.Quote_Attachment} */}
                                Attachment
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Box sx={{ float: "right" }} mb={2}>
                                <div>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={handleDownloadDrawing}
                                        sx={{
                                            minWidth: "35px",
                                            marginRight: "5px"
                                        }}
                                    >
                                        Download
                                    </Button>
                                </div>
                            </Box>
                        </Grid>
                    </Grid>{" "}
                </Box>
            ) : (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="50vh"
                >
                    <ThreeDot
                        color="#1976d2"
                        size="medium"
                        text=""
                        textColor=""
                    />
                </Box>
            )}
        </Box>
    );
};
